export default "__VITE_ASSET__BcHH7ZST__"